import { useQuery } from "@apollo/client"
import { STORE_LIST } from "../queries/storeList"

interface StoreListFilter {
  page?: number
  limit?: number
  active?: number
  countryId?: number
  regionId?: number
  levelId?: number
  gameId?: number
  search?: string
}

interface StoreListParams {
  filter?: StoreListFilter
}

export const useStoreList = (params?: StoreListParams) => {
  const { data, loading, error, refetch } = useQuery(STORE_LIST, {
    variables: {
      StoreListInput: {
        filter: {
          page: 1,
          limit: 12,
          ...params?.filter,
        },
      },
    },
    errorPolicy: "all",
  })

  return {
    stores: data?.StoreList?.Stores || [],
    countries: data?.StoreList?.Countries || [],
    regions: data?.StoreList?.Regions || [],
    total: data?.StoreList?.total || 0,
    pages: data?.StoreList?.pages || 0,
    status: data?.StoreList?.status,
    loading,
    error,
    refetch,
  }
}
